import { currentTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { ISelectedFleetModel } from './FleetButton.model'

export default function SelectedFleet({ fleet }: ISelectedFleetModel) {
  const theme = useAppSelector(currentTheme)
  return <span className={`noselect ${theme}`}>{fleet?.name}</span>
}
